import { Component } from '@angular/core';
import { AbstractBlModal, ModalButtonType } from '@blcloud/bl-ng-ui-component';

/**
 * Yahoo警告モーダルコンポーネント
 */
@Component({
  templateUrl: 'yahoo-warn-modal.component.html',
  styleUrls: ['./yahoo-warn-modal.component.scss'],
})
export class YahooWarnModalComponent extends AbstractBlModal {

  readonly title = '警告';

  /**  フッタボタンタイプ */
  footerButtonType = ModalButtonType.Custom;

  /**
   * @override
   */
  getResults(): any {
    return {};
  }

  /**
   * @override
   */
  onShown() {
  }

  /**
   * キャンセル押下時
   */
  onClickCancel() {
    this.content.cancel();
  }

  /**
   * 決定押下時
   */
  onClickDone() {
    this.content.done();
  }
}



// WEBPACK FOOTER //
// ./src/app/page/biz-menu-page/yahoo-warn-modal/yahoo-warn-modal.component.ts